/**
 * iframe srcDoc 으로 현재 HTML 을 그대로 렌더. Liquid 가 섞인 stage
 * (substitute 이후) 는 완전 렌더되지 않지만 레이아웃·스타일 확인 용도로는 충분.
 */

interface Props {
  html: string
}

export function StagePreview({ html }: Props) {
  return (
    <div style={{ height: '100%', background: '#fff', minHeight: 0 }}>
      <iframe
        key={html.length /* 변경 시 강제 재마운트 */}
        title="stage-preview"
        srcDoc={html || '<html><body style="font-family: sans-serif; color: #999; padding: 20px;">(빈 HTML)</body></html>'}
        sandbox="allow-scripts allow-same-origin"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  )
}
